<script lang="ts">
    import type { OdEditModalManager } from "./OdEditModalManager";
    import OdValueField from "./OdValueField.svelte";
    import OdLocationField from "./OdLocationField.svelte";

    export let manager: OdEditModalManager;
    
    let matrixStore = manager.getMatrix();
    let count = manager.getCount();

    matrixStore.subscribe(_ => {
        count = manager.getCount();
    });
</script>

<table class="table table-sm table-bordered">
    <thead class="thead-dark">
        <tr class="header">
            <th scope="col">#</th>
            {#each {length: count} as _, i}
                <OdLocationField {manager} {i} />
            {/each}
        </tr>
    </thead>
    <tbody>
        {#each {length: count} as _, from}
            <tr>
                <th scope="row">
                    <OdLocationField {manager} i={from} />
                </th>
                {#each {length: count} as _, to}
                    <OdValueField
                        {manager}
                        x={from}
                        y={to} />
                {/each}
            </tr>
        {/each}
    </tbody>
</table>
